import { isSafeAreaFixSupported } from "@/src/utils/safe-area"

// handle store of global parameters
export const state = {
  appStatus: 'init',
  hostname: process.env.VUE_APP_API_URL,
  env: process.env.VUE_APP_ENV,
  allowedHosts: ['o7apps.appspot.com', 'outfit7.com', 'outfit7.net'],
  params: {},
  test: false,
  unreadMessages: 0,
  consentPopupType: false,
  lastConversationRetrieval: 0,
  markedAsRead: false,
  isOldApp: false,
  isHDOTApp: false,
  isSA2App: false,
  isMLApp: false,
  isRatingEnabled: false,
  isSafeAreaFixSupported: true,
  oldAppFilter: [
    'com.outfit7.felis.sampleapp',
    'com.outfit7.jigtyfree',
    'com.outfit7.gingersbirthdayfree',
    'com.outfit7.talkingangelafree',
    'com.outfit7.talkinggingerfree',
    'com.outfit7.tomslovelettersfree',
    'com.outfit7.talkingpierrefree',
    'com.outfit7.talkingnewsfree',
    'com.outfit7.talkingben',
    'com.outfit7.talkingtom',
    'com.outfit7.o7sdksample',
    'felissample',
    'o7puzzles',
    'o7gingersbirthday',
    'o7tomsloveletters',
    'o7sdksample',
    'o7talkingangelaipad',
    'o7talkinggingeripad',
    'o7talkingpierreipad',
    'o7talkingnewsipad',
    'o7talkingtom2ipad',
    'o7talkingbenipad',
    'o7talkingcatipad',
    'o7talkingangela',
    'o7talkingginger',
    'o7talkingpierre',
    'o7talkingnews',
    'o7talkingtom2',
    'o7talkingben',
    'o7talkingcat',
    'com.outfit7.talkingtom2free',
    'com.bemobi.com.outfit7.talkinggingerfree',
    'com.bemobi.com.outfit7.gingersbirthdayfree',
    'com.bemobi.com.outfit7.talkingtompro',
    'com.bemobi.com.outfit7.talkingtom2',
    'com.bemobi.com.outfit7.talkingnews',
    'com.bemobi.com.outfit7.talkingpierre',
    'o7tomsjetski2',
    'com.outfit7.talkingtomjetski2',
    'com.outfit7.TalkingGinger.huawei',
    'com.outfit7.TalkingGinger.nearme.gamecenter',
    'com.outfit7.TalkingGinger.vivo',
    'com.outfit7.TalkingGinger.mi',
    'com.outfit7.TalkingGinger.mz',
    'com.outfit7.TalkingGinger.uc',
    'com.outfit7.TalkingGinger.jk',
    'com.outfit7.TalkingGinger.jinli',
  ],
  hdotAppFilter: [
    'com.hyperdotstudios.triumphoflegends',
    'com.hyperdotstudios.mythiclegends',
    'com.hyperdotstudios.dtte',
    'com.hyperdotstudios.slimesquadarena',
    'com.hyperdotstudios.path.hopper',
    'com.hyperdotstudios.swampattack2',
    'hdstriumphoflegends',
    'hdsmythiclegends',
    'hdsslimesquadarena',
    'hdsswampattack2',
  ],
  sa2AppFilter: ['com.hyperdotstudios.swampattack2', 'hdsswampattack2'],
  mlAppFilter: [
    'com.hyperdotstudios.triumphoflegends',
    'com.hyperdotstudios.mythiclegends',
    'hdstriumphoflegends',
    'hdsmythiclegends',
  ],
  ratingEnabledFilter: [
    'com.outfit7.mytalkingtom',
    'com.outfit7.mytalkingtom2',
    'com.outfit7.mytalkingangela',
    'com.outfit7.mytalkingangela2',
    'com.outfit7.mytalkingtomfriends',
    'com.outfit7.herodash',
    'com.outfit7.talkingtomgoldrun',
    'com.hyperdotstudios.mythiclegends',
    'com.hyperdotstudios.swampattack2',
    'com.outfit7.tomgoldrun2',
    'o7talkingtomgoldrun2',
    'o7mytalkingangela2',
    'o7mytalkingangela',
    'hdsmythiclegends',
    'hdsswampattack2',
    'o7mytalkingtomfriends',
    'o7herodash',
    'o7mytalkingtom2',
    'o7mytalkingtom',
    'o7talkingtomgoldrun'
  ],
  testParams: {
    // test=true - populate testing parameters
    aId: 'com.outfit7.mytalkingtom2',
    u: 'sZGLpvvADzwl0pSVd7SwmS3gegNGqGTxUvGhtLazu3AIJLY_um1RC9TXh93PlmnSBojx',
    s: '7f2d64c5708b688628a903f3777958007b4f9554',
    t: '1586250375113',
    lC: 'ru-SI',
    aV: '4.5.4.643',
    lV: '13.6.5-navidad2',
    p: 'Android',
    tZO: '3600',
    aGP: true,
    ss: true,
    bH: 'test.outfit7.org',
  },
  supportedLocales: [
    'en',
    'zh',
    'ja',
    'ko',
    'de',
    'fr',
    'es',
    'pt',
    'it',
    'ru',
    'tr',
    'ar',
    'vi',
    'id',
    'th',
    'zh-hant',
    'zh-trad',
    'zh-simp',
    'zh-csm'
  ],
}

export const getters = {
  params: (state) => {
    return state.params
  },
  unread: (state) => {
    return state.unreadMessages
  },
  consentPopup: (state) => {
    return state.consentPopupType
  },
  status: (state) => {
    return state.appStatus
  },
  platform: (state) => {
    return state.params.p
  },
  // locale (if set use what was provided, otherwise fallback to navigator locale)
  locale: (state) => {
    if (state.params.csm && state.params.csm === 'true') return 'zh-csm' // Android CSM (Chinese Store Mode) check
    if (state.isOldApp) return 'en' // if it's an old app, we don't enable localisation support
    // otherwise, proceed to determine localisation to be used
    var loc = state.params.lC
      ? state.params.lC.toLowerCase()
      : navigator.language
      ? navigator.language.toLowerCase()
      : navigator.userLanguage.toLowerCase()

    if (['zh-tw', 'zh_tw', 'zh-hant', 'zh_hant', 'zh-trad', 'zh_trad'].includes(loc)) return 'zh-hant'
    else return state.supportedLocales.includes(loc.substring(0, 2)) ? loc.substring(0, 2) : 'en'
  },
  hyperdotApp: (state) => {
    return state.isHDOTApp
  },
  mlApp: (state) => {
    return state.isMLApp
  },
  sa2App: (state) => {
    return state.isSA2App
  },
  oldApp: (state) => {
    return state.isOldApp
  },
  ratingEnabled: (state) => {
    return state.isRatingEnabled
  },
  safeAreaFixSupported: (state) => {
    return state.isSafeAreaFixSupported
  }
}

// mutations always need to run synchronsly
export const mutations = {
  // save topics and messages to topics[]
  SAVE_PARAMS(state, payload) {
    state.params = payload
  },
  UPDATE_HOSTNAME(state, payload) {
    state.hostname = payload
  },
  TEST_PARAMS(state, payload) {
    state.test = true
    state.params = state.testParams
  },
  SAVE_UNREAD_COUNT(state, payload) {
    state.unreadMessages = payload
  },
  SAVE_CONSENT_POPUP_TYPE(state, payload) {
    state.consentPopupType = payload
  },
  UPDATE_TIMESTAMP(state, payload) {
    if (!state.test) {
      state.params.t = payload
    }
  },
  UPDATE_STATUS(state, payload) {
    state.appStatus = payload
  },
  MARK_READ(state, payload) {
    state.markedAsRead = payload
  },
  UPDATE_CONV_TIMESTAMP(state, payload) {
    state.lastConversationRetrieval = payload
  },
  UPDATE_OLDAPP(state, payload) {
    state.isOldApp = payload
  },
  UPDATE_HDOTAPP(state, payload) {
    state.isHDOTApp = payload
  },
  UPDATE_MLAPP(state, payload) {
    state.isMLApp = payload
  },
  UPDATE_SA2APP(state, payload) {
    state.isSA2App = payload
  },
  UPDATE_RATINGENABLED(state, payload) {
    state.isRatingEnabled = payload
  },
  UPDATE_SAFEAREAFIXSUPPORTED(state, payload) {
    state.isSafeAreaFixSupported = payload
  },
}

export const actions = {
  // updates query paramteres
  updateParams({ commit, rootState }, payload) {
    // check if bH is set (backend Hostname) & we are in production
    if (payload.bH && rootState.globals.env === 'production') {
      for (const h in rootState.globals.allowedHosts) {
        // iterate through allowed hosts and make sure the supplied hostname is part of the allowed host domain
        if (payload.bH.endsWith(rootState.globals.allowedHosts[h])) {
          var bh = payload.bH.includes('https://')
            ? payload.bH
            : 'https://' + payload.bH
          commit('UPDATE_HOSTNAME', bh)
        }
      }
    }
    if (payload.aId) {
      if (
        rootState.globals.ratingEnabledFilter.filter((f) => {
          return payload.aId.includes(f)
        }).length > 0
      ) {
        commit('UPDATE_RATINGENABLED', true)
      }
    }
    commit('UPDATE_SAFEAREAFIXSUPPORTED', isSafeAreaFixSupported(payload.lV, payload.p))
    
    commit('SAVE_PARAMS', payload)
    if (
      rootState.globals.oldAppFilter.filter((f) => {
        // return payload.aId.includes(f)
        if (payload.aId === f) return true
        return false
      }).length > 0
    ) {
      commit('UPDATE_OLDAPP', true)
    }
    if (
      rootState.globals.hdotAppFilter.filter((f) => {
        return payload.aId.includes(f)
      }).length > 0
    ) {
      commit('UPDATE_HDOTAPP', true)
      if (
        rootState.globals.mlAppFilter.filter((f) => {
          return payload.aId.includes(f)
        }).length > 0
      ) {
        commit('UPDATE_MLAPP', true)
      }
      if (
        rootState.globals.sa2AppFilter.filter((f) => {
          return payload.aId.includes(f)
        }).length > 0
      ) {
        commit('UPDATE_SA2APP', true)
      }
    }
  },
  testParams({ commit, rootState }, payload) {
    // check if bH is set (backend Hostname)
    if (state.testParams.bH) {
      for (const h in rootState.globals.allowedHosts) {
        // iterate through allowed hosts and make sure the supplied hostname is part of the allowed host domain
        if (state.testParams.bH.endsWith(rootState.globals.allowedHosts[h])) {
          var bh = state.testParams.bH.includes('https://')
            ? state.testParams.bH
            : 'https://' + state.testParams.bH
          commit('UPDATE_HOSTNAME', bh)
        }
      }
    }
    commit('TEST_PARAMS', payload)
    if (
      rootState.globals.oldAppFilter.filter((f) => {
        return state.testParams.aId.includes(f)
      }).length > 0
    ) {
      commit('UPDATE_OLDAPP', true)
    }
    if (
      rootState.globals.hdotAppFilter.filter((f) => {
        return state.testParams.aId.includes(f)
      }).length > 0
    ) {
      commit('UPDATE_HDOTAPP', true)
      if (
        rootState.globals.mlAppFilter.filter((f) => {
          return state.testParams.aId.includes(f)
        }).length > 0
      ) {
        commit('UPDATE_MLAPP', true)
      }
      if (
        rootState.globals.sa2AppFilter.filter((f) => {
          return state.testParams.aId.includes(f)
        }).length > 0
      ) {
        commit('UPDATE_SA2APP', true)
      }
    }
  },
  unreadMessages({ commit }, payload) {
    commit('SAVE_UNREAD_COUNT', payload)
  },
  updateStatus({ commit }, payload) {
    commit('UPDATE_STATUS', payload)
  },
  resetUnread({ commit }, payload) {
    commit('SAVE_UNREAD_COUNT', payload)
  },
}
